<template>
  <router-link
    class="kanban-banner"
    :to="{
      name: 'Painel Atividades',
      params: { section: 'atendimentos' },
      query: { mode: 'kanban' }
    }"
    aria-label="Acessar o Kanban de atendimentos"
  >
    <div class="kanban-banner-content">
      <span class="kanban-banner-label">Painel de Atividades</span>
      <h2>Priorize seu trabalho no Kanban</h2>
      <p>Acompanhe pendências, prazos e atribuições em uma visão organizada por etapa.</p>
      <span class="kanban-banner-action">
        Minhas Atividades
        <fa :icon="['fal', 'arrow-right-long']" />
      </span>
    </div>

    <div class="kanban-banner-visual" aria-hidden="true">
      <span class="kanban-banner-icon">
        <fa :icon="['fal', 'square-kanban']" />
      </span>
      <div class="kanban-columns">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'HomeKanbanBanner'
}
</script>

<style lang="scss" scoped>
.kanban-banner {
  position: relative;
  display: flex;
  min-height: 230px;
  overflow: hidden;
  border-radius: $border-radius-large;
  background:
    radial-gradient(circle at 85% 20%, rgba(255, 255, 255, .22), transparent 30%),
    linear-gradient(135deg, #ed1c24 0%, #c91131 58%, #8f1232 100%);
  box-shadow: 0 18px 44px rgba(148, 25, 30, .22);
  color: $color-secondary;
  padding: $mg_mid;
  transition: box-shadow .2s ease, transform .2s ease;

  &::after {
    position: absolute;
    right: -90px;
    bottom: -120px;
    width: 320px;
    height: 320px;
    border: 1px solid rgba(255, 255, 255, .13);
    border-radius: 50%;
    content: '';
  }

  &:hover {
    color: $color-secondary;
    box-shadow: 0 22px 52px rgba(148, 25, 30, .3);
    transform: translateY(-2px);

    .kanban-banner-action svg { transform: translateX(4px); }
    .kanban-banner-visual { transform: translateY(-50%) rotate(-2deg) scale(1.02); }
  }
}

.kanban-banner-content {
  position: relative;
  z-index: 2;
  display: flex;
  width: 58%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  h2 {
    max-width: 430px;
    margin: $mg_mini 0 8px;
    color: inherit;
    font-size: 28px;
    line-height: 1.1;
  }

  p {
    max-width: 470px;
    margin: 0;
    color: rgba(255, 255, 255, .78);
    font-size: 14px;
    line-height: 1.45;
  }
}

.kanban-banner-label {
  border: 1px solid rgba(255, 255, 255, .26);
  border-radius: 999px;
  background: rgba(255, 255, 255, .12);
  padding: 6px 11px;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.kanban-banner-action {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  min-height: 40px;
  margin-top: $hmg_mid;
  border-radius: 999px;
  background: $color-secondary;
  color: $color-primary;
  padding: 0 17px;
  font-weight: 900;

  svg { transition: transform .2s ease; }
}

.kanban-banner-visual {
  position: absolute;
  z-index: 1;
  top: 50%;
  right: $mg_mid;
  display: flex;
  width: 32%;
  min-width: 220px;
  height: 150px;
  flex-direction: column;
  gap: $mg_mini;
  border: 1px solid rgba(255, 255, 255, .3);
  border-radius: $border-radius;
  background: rgba(255, 255, 255, .12);
  box-shadow: 0 18px 38px rgba(65, 7, 25, .22);
  padding: $hmg_small;
  transform: translateY(-50%) rotate(2deg);
  transition: transform .2s ease;
  backdrop-filter: blur(7px);
}

.kanban-banner-icon {
  display: flex;
  width: 42px;
  height: 42px;
  align-items: center;
  justify-content: center;
  border-radius: $border-radius-small;
  background: $color-secondary;
  color: $color-primary;
  font-size: 21px;
}

.kanban-columns {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;

  span {
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    background: rgba(255, 255, 255, .16);

    &::before,
    &::after {
      position: absolute;
      right: 6px;
      left: 6px;
      height: 17px;
      border-radius: 4px;
      background: rgba(255, 255, 255, .8);
      content: '';
    }

    &::before { top: 8px; }
    &::after { top: 31px; opacity: .48; }
  }
}

@media screen and (max-width: 740px) {
  .kanban-banner {
    min-height: 250px;
    padding: $hmg_mid;
  }

  .kanban-banner-content { width: 70%; }
  .kanban-banner-content h2 { font-size: 23px; }
  .kanban-banner-visual {
    right: -95px;
    width: 230px;
    opacity: .72;
  }
}

@media screen and (max-width: 480px) {
  .kanban-banner-content { width: 100%; }
  .kanban-banner-content p { max-width: 85%; }
  .kanban-banner-visual { right: -145px; opacity: .42; }
}
</style>
